import { Box, Grid, Collapse, useTheme, useMediaQuery, Typography, Link } from "@mui/material";
import Header from "../../common/Header";
import Card from "../../common/Card";
import Button from "../../common/Button";
import { ArchiveOutlined, ArchiveRounded, ArchiveSharp, ArchiveTwoTone, AssignmentReturnedOutlined, Checklist, DownloadDoneOutlined, FileOpenOutlined, ModeOutlined, NoteAddOutlined, Notifications, NotificationsOutlined, PictureAsPdfOutlined, SearchOutlined, TrackChanges, VisibilityOutlined, CloudDownload, DownloadOutlined, KeyboardArrowDown, ExitToApp, ListAltOutlined} from "@mui/icons-material";
import Table, { Row as TableRow } from "../../common/CustomTable";
import { useLocation, useNavigate } from "react-router-dom";
import { usePracticeSlice, searchPracticeList, SearchPracticeRequest, fetchDocumentById, resetPracticeInfo, getUpdatedPracticeRegistrationByPracticeId } from "../../../redux/slice/practiceSlice";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { useForm } from "react-hook-form";
import CustomTextField from "../../common/CustomTextField";
import { fetchPracticeByIdData } from "../../../redux/slice/practice/practiceEditSlice"
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { fullName, formatDate, hideElement, sortNames } from "../../../utils/Utility";
import { createListSort } from "../../../utils/listSort";
import CustomPatternTextField from "../../common/CustomPatternTextField";
import { AgencyInfo, SingleAlertInfo, setSingleAlertObj } from "../../../redux/slice/commonSlice";
import PDFViewer from "../../common/pdf/PDFViewer";
import LegacyToolBar from "../../common/LegacyToolBar";
import CustomIconButton from "../../common/CustomIconButton";
import PracticeApprovePopup from "./PracticeApprovePopup";
import { selectIsValueFoundInToken, selectTokenValues, useAuthSlice } from "../../../redux/slice/authSlice";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import { AUDIT_ENTITYS, CAN_ACCESS_APPLICATION, PRACTICE_STATUS, EXPORTABLE_ITEMS, USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../../../constants/applicationConstants";
import { getSearchCriteriaFromSessionStorage, saveSelectionForPage, setSearchCriteriaToSessionStorage } from "../../../utils/StorageUtils";
import { getOverrideAgencyCommissions, SearchAgency } from "../../../redux/slice/agency/AgencySlice";
import { fetchActiveAgencyExecutives } from "../../../redux/slice/practice/practiceApproveSlice";
import { usePracticeApproveSlice } from "../../../redux/slice/practice/practiceApproveSlice";
import { getAllAgenciesList } from "../../../service/CommonService";
import UploadBaaPopup from "../baa/UploadBaaPopup";
import { PracticeInfo } from "../../../redux/slice/practice/practiceRegistrationSlice";
import CustomSingleAlert from "../../common/CustomSingleAlert";
import { getPracticesByUserRoleUserSlice, useUserReducer } from "../../../redux/slice/userSlice";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import { acknowledgeNotification, fetchAlertEntityNumbers, fetchNotificationsByRefEntities, useCreateNotificationSlice } from "../../../redux/slice/inbox/createNotificationSlice";
import StatusInfoPopup from "../../common/StatusInfoPopup";
import ExportToExcel from "../../common/ExportToExcel";
import { MenuItem, ListItemIcon } from "@mui/material";
import StyledMenu from "../../common/StyledMenu";
import { useListPageStyles } from "../../common/useListPageStyles";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left"; // Adjust the align property type
  format?: (value: number) => string;
}

interface Row {
  contactName: string;
  practiceName: string;
  practiceNameLink?:string | JSX.Element; // CS-1406 - Rendering practice name as link
  approvalStatus: string | JSX.Element;
  rawApprovalStatus?: string; // CS-1555 - for logic on row click
  contactEmail: string;
  createdDate : String
  action: JSX.Element | null;
  practiceId: string;
  agencyName: string;
}

type Option = {
  value: string,
  label: string
};


interface DropdownDisable {
  field: string;
  isDisabled: boolean;
}



// Define columns and rows data
const columns: Column[] = [
  // { id: "practiceName", label: "Practice Name", minWidth: 100 },
  { id: "practiceNameLink", label: "Practice Name", minWidth: 100 }, //CS-1406 - Rendering practice name as link
  { id: "contactName", label: "Contact Name", minWidth: 100 },
  { id: "contactEmail", label: "Contact Email", minWidth: 100 },
  { id: "contactPhone", label: "Contact Phone Number", minWidth: 100 },
  { id: "createdDate", label: "Created Date", minWidth: 100 },
  { id: "agencyName", label: "Agency", minWidth: 100 },
  { id: "userId", label: "Account Rep", minWidth: 100 },
  { id: "approvalStatus", label: "Status", minWidth: 100 },
  { id: "action", label: "Action", minWidth: 50, align: "center", },
];

const ITEMS_PER_PAGE = 20;

const practiceListSort = createListSort(
  ["practiceName", "contactName", "contactEmail", "createdDate", "agencyName", "accountRepName", "approvalStatus"] as const,
  {
    practiceNameLink: "practiceName",
    contactName: "contactName",
    contactEmail: "contactEmail",
    createdDate: "createdDate",
    agencyName: "agencyName",
    userId: "accountRepName",
    approvalStatus: "approvalStatus",
  }
);

const PracticeList = () => {

  const location = useLocation();
  const { navigate } = useNavigation();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    cardSx,
    filterPanelSx,
    primaryActionBtnSx,
    outlineBtnSx,
    exportMenuPaperSx,
    exportMenuItemBtnSx,
    tableSx,
  } = useListPageStyles();

  const exportBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: "#14B8A6",
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      color: "#14B8A6",
    },
    "&:hover": {
      color: "#fff",
      borderColor: "#14B8A6",
      backgroundColor: "#14B8A6",
      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
      "& .MuiSvgIcon-root": {
        color: "#fff",
      },
    },
  };

  const { control, handleSubmit, reset, setValue } = useForm<SearchPracticeRequest>();

  const [showCard, setShowCard] = useState(false);
  const {
    filterPanelRef,
    toggleFilterPanel,
    handleFilterPanelEntering,
    handleFilterPanelEntered,
    handleFilterPanelExited,
  } = useFilterPanelFocus(showCard, setShowCard);
  const [showPDF, setShowPDF] = useState(false);
  const [showPracticesPopup, setShowPracticesPopup] = useState(false);
  const [showBaaPopup, setShowBaaPopup] = useState<{show: boolean, userEntity: "PRACTICE" | "USER", details:PracticeInfo | null}>();
  const [baaAlert, setBaaAlert] = useState<{show:boolean, obj: SingleAlertInfo}>();
  //CS-1071 - Start
  const [activeButtonId, setActiveButtonId] = useState<string | null>(null);
  //CS-1071 - End
  const [searchCriteria, setSearchCriteria] = useState<SearchPracticeRequest>({
    practiceId: null,
    contactFirstName: '',
    contactLastName: '',
    contactEmail: '',
    contactPhone: '',
    approvalStatus: '',
    agencyId: null,
    userId: null,
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
  });

  const { practiceInfo, document } = usePracticeSlice(); // Use the practiceInfo from the Redux store
  const { userInfo } = useAuthSlice();

  const {agencyExecutives} = usePracticeApproveSlice();

  const canAccessPracticeActionsView = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.VIEW)(state));
  const canAccessPracticeActionsEdit = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.EDIT)(state));
  const canAccessPracticeActionsPreview = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.PREVIEW)(state));
  const canAccessPracticeActionsApprove = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.APPROVE)(state));
  const canAccessPracticeActionsAchieve = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.ACHIEVE)(state));
  const canAccessPracticeActionsImportBaa = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.IMPORT_BAA)(state));
  const canAuditPractice = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.PRACTICEAUDIT)(state));
  const accessibleNotifications = useSelector((state: RootState) => selectTokenValues("canAccessNotifications")(state));
  const canAccessNotifications = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.NOTIFICATION_MANAGEMENT)(state));

  const [agencyInfoList, setAgencyInfoList] = useState<AgencyInfo>();
  const [isAlertOnly, setIsAlertOnly] = useState<boolean>(false);
  const [alertedPracticeIds, setAlertedPracticeIds] = useState<number[]>([]);
  const { NotificationInfoByRefEntity} = useCreateNotificationSlice();
  const [notificationData, setNotificationData] = useState<any[]>([]);
  const [statusAnchorEl, setStatusAnchorEl] = useState<HTMLElement | null>(null);
  const [totalNotificationIds, setTotalNotificationIds] = useState([]);
  //CS-1370 - Start
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const [fetchPracticesCompleted, setFetchPracticesCompleted] = useState<boolean>(false);

  const canExportPracticeList = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORTABLE_ITEMS.PRACTICE)(state));

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorElMenu(null);
  };
  //CS-1370 - End

  const { practiceByUserRoleUserSlice } = useUserReducer();

  const statusOptions = useMemo(() => {
    let options: { label: string, value: any }[] = [
      { value: "ALL", label: "ALL" },
      { value: "SUBMITTED", label: "SUBMITTED" },
      { value: "APPROVED", label: "APPROVED" },      
      { value: "PENDING", label: "PENDING" },
      { value: "REJECTED", label: "REJECTED" },
    ];
    return options;
  }, []);

  //Mount
  useEffect(() => {
    const fromBaa = location?.state?.fromBaa;
    if(fromBaa) {
      notifyBaaAlert();
    };
  }, []);
 //CS-1071 - Start
  useEffect(() => {
    const saved = sessionStorage.getItem("activeActionButtonId");
    if (saved) {
      setActiveButtonId(saved);
    }
  }, []);
  //CS-1071 - End
  const notifyBaaAlert = () => {
    let infoObj: SingleAlertInfo = {
      message: "Please upload the Business Association Agreement by selecting the Import BAA option in the action menu.",
      alertType: "info"
    }
    setBaaAlert({
      show: true,
      obj: infoObj
    });
  }

  //Unmount
  useEffect(() => () => {
    dispatch(resetPracticeInfo());
  }, []);

  useEffect(() => {
    //1. When login another user pagination is remain in the history and can redirect that page
    let criteria = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.PRACTICE + "SearchCriteria" + userInfo.userId);
    if ((location.state && location.state.practiceListSearchCriteria) || (location.state && location.state.withSearchHistory && criteria)) {
      if (location.state && location.state.withSearchHistory) {
        //Below navigate line call back to this useEffect - This for refreshing issue when navigate with state.withSearchHistory=true
        navigate("/practice_list", { state: { practiceListSearchCriteria: criteria } });
        return;
      }
      let searchCriteria: SearchPracticeRequest = {
        practiceId: null,
        contactFirstName: '',
        contactLastName: '',
        contactEmail: '',
        contactPhone: '',
        approvalStatus: '',
        agencyId: null,
        userId: null,
        currentPage: 0,
        itemsPerPage: 0
      };
      if (location.state && location.state.practiceListSearchCriteria) {
        location.state.practiceListSearchCriteria.alertPractices = isAlertOnly ? true : false;
        searchCriteria = location.state.practiceListSearchCriteria;
      } else {
        if(criteria){
          criteria.alertPractices = isAlertOnly ? true : false;
        }
        searchCriteria = criteria ? criteria : searchCriteria;
      }
      setSearchCriteria(searchCriteria);
      setValuesToCriteriaFields(searchCriteria);

      searchPracticesList(searchCriteria);
    } else {
      if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
        loadInitialPracticeList(1);
      }
    }
  }, [location.state, showBaaPopup?.show, agencyInfoList]);

  const setValuesToCriteriaFields = (searchCriteria: SearchPracticeRequest) => {
    setValue("practiceId", searchCriteria.practiceId);
    setValue("contactFirstName", searchCriteria.contactFirstName);
    setValue("contactLastName", searchCriteria.contactLastName);
    setValue("contactEmail", searchCriteria.contactEmail);
    setValue("contactPhone", searchCriteria.contactPhone);
    setValue("approvalStatus", searchCriteria.approvalStatus);
    setValue("agencyId", searchCriteria.agencyId);
    setValue("userId", searchCriteria.userId);
  }

  const loadInitialPracticeList = (pNumber: number = 1) => {
    const agencyId = Array.isArray(agencyInfoList) && agencyInfoList.length === 1 
    ? agencyInfoList[0]?.agencyId
    : null; 

    let data : SearchPracticeRequest;
    if (userInfo.entityName ===  USER_ROLE_ENTITY_NAMES.ADMIN) {
      data = {
        practiceId: null,
        contactFirstName: "",
        contactLastName: "",
        contactEmail: "",
        contactPhone: "",
        approvalStatus: "",
        agencyId: null,
        userId: null,
        currentPage: pNumber,
        itemsPerPage: ITEMS_PER_PAGE,
        alertPractices : isAlertOnly ? true : false
      };
    } else{
        data = {
          practiceId: null,
          contactFirstName: "",
          contactLastName: "",
          contactEmail: "",
          contactPhone: "",
          approvalStatus: "",
          agencyId: agencyId,
          userId:userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE ? userInfo.userId : null,
          currentPage: pNumber,
          itemsPerPage: ITEMS_PER_PAGE,
          alertPractices : isAlertOnly ? true : false
        };  

      }
    setSearchCriteria(data);
    setValuesToCriteriaFields(data);
    
    searchPracticesList(data);
  }

  const searchPracticesList = (searchCriteria: SearchPracticeRequest) => {
    const normalizedCriteria = practiceListSort.normalize(searchCriteria);
    setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.PRACTICE + "SearchCriteria" + userInfo.userId, normalizedCriteria);
    
    let dataToSearch = {
      ...normalizedCriteria,
      approvalStatus: normalizedCriteria.approvalStatus === "ALL" ? "" : normalizedCriteria.approvalStatus,
    }

    dispatch(searchPracticeList(dataToSearch));
  }

  const onSubmit = (data: SearchPracticeRequest) => {
    const data2: SearchPracticeRequest = {
      practiceId: typeof data.practiceId === "number" ? data.practiceId : null,
      contactFirstName: data.contactFirstName,
      contactLastName: data.contactLastName,
      contactEmail: data.contactEmail,
      contactPhone: data.contactPhone,
      approvalStatus: data.approvalStatus,
      agencyId: typeof data.agencyId === "number" ? data.agencyId : null,
      userId: typeof data.userId === "number" ? data.userId : null,
      currentPage: 1,
      itemsPerPage: ITEMS_PER_PAGE,
      ...practiceListSort.pick(searchCriteria),
    }
    setSearchCriteria(data2);

    //Below navigate line call to useEffect[location.state] and search
    navigate("/practice_list", {state: {practiceListSearchCriteria : data2}});
  }

  const handlePagination = (pageNumber: number) => {
    const data = {
      ...searchCriteria,
      currentPage: pageNumber + 1
    }
    setSearchCriteria(data);

    //Below navigate line call to useEffect[location.state] and search
    navigate("/practice_list", { state: { practiceListSearchCriteria: data } });
  }

  const handleTableSort = (columnId: string, order: "asc" | "desc") => {
    const data = practiceListSort.withSort(searchCriteria, columnId, order);
    if (!data) {
      return;
    }
    setSearchCriteria(data);
    navigate("/practice_list", { state: { practiceListSearchCriteria: data } });
  }
  // CS-1370 - Start
  const handleExport = (exportType: string) => {
    const searchCriteriaFromStorage = getSearchCriteriaFromSessionStorage(
      CAN_ACCESS_APPLICATION.PRACTICE +
      "SearchCriteria" +
      userInfo.userId
    );

    if (searchCriteriaFromStorage) {
      let dataToSearch = {
        ...searchCriteria,
        currentPage: searchCriteriaFromStorage.currentPage,
        downloadState: true
      };

      ExportToExcel(
        dataToSearch,
        columns,
        dispatch,
        exportType === "details" ? EXPORTABLE_ITEMS.PRACTICE_DETAILS : EXPORTABLE_ITEMS.PRACTICE
      );
    }
    handleMenuClose();
  };
  // CS-1370 - End
  
  const handleActionEdit = (row: any) => {
    const { rawApprovalStatus } = row; // CS-1555
    navigate("/practice_edit_view", { state: { practiceEditInfo: { rawApprovalStatus }, practiceId: row.practiceId, documentId: row.associateAgreementDocumentId } }); // CS-1555
  }

  const handlePracticeAchievePreview = async (row: any) => {
    if (row.associateAgreementDocumentId !== null) {
      const actionResult = await dispatch(fetchDocumentById(row.associateAgreementDocumentId));
      const documentData = actionResult.payload;
      if (documentData && documentData.content) {
        setShowPDF(true);
      }
    } else {
      let errorObj: SingleAlertInfo = {
        message: "Feature currently under development. Stay tuned for updates!",
        alertType: "info"
      }
      dispatch(setSingleAlertObj(errorObj));
    }
  }

  const handleApproveAction = async (row: any) => {
    const response = await dispatch(fetchPracticeByIdData(row.practiceId));
    if (response.payload) {
      navigate('/practice_request', { state: { rowValue: response.payload?.data } })
    }
  }

  const handleActionPreview = async (row: any) => {
    const data = {
      practiceId: row.practiceId,
      updatePracticeAgreement: false,
    };
    const response = await dispatch(getUpdatedPracticeRegistrationByPracticeId(data));
    const documentData = response.payload;

    if (documentData && documentData.data) {
      setShowPDF(true);
    }
    else {
      let errorObj: SingleAlertInfo = {
        message: "Feature currently under development. Stay tuned for updates!",
        alertType: "info"
      }
      dispatch(setSingleAlertObj(errorObj));
    }
  }

  const handleClose = () => {
    setShowPDF(false);
  }

  const handleImportBaa = (row: any) => {
    setShowBaaPopup({
      show: true,
      userEntity: "PRACTICE",
      details: row
    });
  }
  const handleClickPracticeAudit = (data: any) => {
    if (data && data.practiceName) {
      const PracticeAuditData = {
        entityName: "PRACTICE",
        entityNumber: data?.practiceName
      }

      const url = `/auditlog?entityName=${PracticeAuditData.entityName}&entityNumber=${PracticeAuditData.entityNumber}`;
      window.open(url, '_blank');
      // navigate("/auditlog", '_blank',{ state: { entityName: IVRAuditData.entityName, entityNumber: IVRAuditData.entityNumber } });
    }
  }
   //CS-1071 - Start
    const handleActionButtonClick = (buttonId: string, originalClick: () => void) => {
      const currentPageKey = "practiceList"; // Or dynamically set this value based on the current page
      saveSelectionForPage(currentPageKey, buttonId);
      setActiveButtonId(buttonId);
      sessionStorage.setItem("activeActionButtonId", buttonId);
      originalClick(); // Call the button's actual logic
    };
    //CS-1071 - End

  const handlePracticeInfoPreview = async (row: any) => {
    const response = await dispatch(fetchPracticeByIdData(row.practiceId.toString()));
    if (response?.payload?.data) {
      dispatch(getOverrideAgencyCommissions(row.practiceId)); //CS-1234
      setShowPracticesPopup(true);
    };
  };
  const handlePracticeDetailsView = async (row: any) => {
  navigate("/practiceDetails", { state: { practiceData: row} });
  };

  const handlePracticeDetailsViewOnRowClick = async (row: any) => {
    // Remove common UI-only fields
    const safeRow: any = { ...row };
    delete safeRow.action;
    delete safeRow.practiceNameLink;
    safeRow.approvalStatus = row.rawApprovalStatus ?? (typeof row.approvalStatus === "string" ? row.approvalStatus : "");
    navigate("/practiceDetails", { state: { practiceData: safeRow } });
  };

  // CS-1555 - Start
  const handleRowNavigateToEdit = (row: TableRow) => {
    const status = (row as any).rawApprovalStatus;
    const practiceId = String(row.practiceId);

    // Navigate submitted rows to Approve screen
    if (status === "SUBMITTED") {
      if (!canAccessPracticeActionsApprove) return;
      handleActionButtonClick(`practiceListActionButton-${practiceId}`, () => handleApproveAction(row));
      return;
    }

    // Navigate approved/rejected rows to Edit screen
    if (status === "APPROVED" || status === "REJECTED") {
      if (!canAccessPracticeActionsEdit) return;
      handleActionButtonClick(`practiceListActionButton-${practiceId}`, () => handlePracticeDetailsViewOnRowClick(row));
    }
  };
  // CS-1555 - End

  const actionComponent = (row: any): JSX.Element | null => {
    const { approvalStatus ,practiceId } = row;

    // Check if any buttons should be rendered
    const shouldShowPdfButton = ((approvalStatus === "APPROVED" || approvalStatus === "REJECTED") && approvalStatus === "APPROVED") && canAccessPracticeActionsPreview;
    const shouldShowEditButton = (approvalStatus === "APPROVED" || approvalStatus === "REJECTED") && canAccessPracticeActionsEdit;
    const shouldShowApproveButton = (!(approvalStatus === "APPROVED" || approvalStatus === "REJECTED")) && canAccessPracticeActionsApprove;
    const shouldShowViewButton = approvalStatus === "APPROVED" && canAccessPracticeActionsView;
    const shouldShowArchiveButton = approvalStatus === "APPROVED" && canAccessPracticeActionsAchieve;
    const shouldShowImportBaaButton = approvalStatus === "APPROVED" && canAccessPracticeActionsImportBaa && row.baaDetailId === null;
    const shouldShowAuditButton = canAuditPractice;

    // If no buttons should be shown, return null
    if (!shouldShowPdfButton && !shouldShowEditButton && !shouldShowApproveButton &&
      !shouldShowViewButton && !shouldShowArchiveButton && !shouldShowImportBaaButton &&
      !shouldShowAuditButton) {
      return null;
    }

    return (
      <>

        {approvalStatus === "APPROVED" &&
          (<CustomIconButton color="info" size="small" variant="outlined" onClick={() => handleActionButtonClick(`practiceListActionButton-${practiceId}`, () => handlePracticeDetailsView(row))} tooltipMessage="Detail"
            tooltipPlacement='top'
            style={{ display: `${hideElement(!canAccessPracticeActionsView)}` }}
          >
            <ListAltOutlined fontSize="small" />
          </CustomIconButton>
        )}

        {((approvalStatus === "APPROVED" || approvalStatus === "REJECTED") && approvalStatus === "APPROVED") &&
          (<CustomIconButton color="info" size="small" variant="outlined"
            //CS-1071 - Start 
            onClick={() => handleActionButtonClick(`practiceListActionButton-${practiceId}`, () =>handleActionPreview(row))}
            //CS-1071 - End
            tooltipMessage="PDF" tooltipPlacement='top' style={{ display: `${hideElement(!canAccessPracticeActionsPreview)}` }}>
            <PictureAsPdfOutlined fontSize='small' />
          </CustomIconButton>
          )}
        {(approvalStatus === "APPROVED" || approvalStatus === "REJECTED") && (
          <CustomIconButton color="info" size="small" variant="outlined" 
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`practiceListActionButton-${practiceId}`, () =>handleActionEdit(row))}
          //CS-1071 - End
          tooltipMessage="Edit" tooltipPlacement='top' style={{ display: `${hideElement(!canAccessPracticeActionsEdit)}` }}>
            <ModeOutlined fontSize='small' />
          </CustomIconButton>
        )}
        {(!(approvalStatus === "APPROVED" || approvalStatus === "REJECTED" || approvalStatus === "PENDING") &&
          <CustomIconButton color="success" size="small" variant="outlined"
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`practiceListActionButton-${practiceId}`, () =>handleApproveAction(row))}
          //CS-1071 - End
          tooltipMessage="Approve" tooltipPlacement='top' style={{ display: `${hideElement(!canAccessPracticeActionsApprove)}` }}>
            <Checklist fontSize="small" />
          </CustomIconButton>
        )}
        {/* CS-1406 - Not accessing view from practice list */}
        {/* {approvalStatus === "APPROVED" &&
          (<CustomIconButton color="info" size="small" variant="outlined" onClick={() => handlePracticeInfoPreview(row)} tooltipMessage="View"
            tooltipPlacement='top'
            style={{ display: `${hideElement(!canAccessPracticeActionsView)}` }}
          >
            <NoteAddOutlined fontSize="small" />
          </CustomIconButton>)} */}
        {/* CS-1406 - New practice details button added and view icon will be removed  */}

        {approvalStatus === "APPROVED" &&
          (<CustomIconButton color="info" size="small" variant="outlined"
            //CS-1071 - Start
            onClick={() =>handleActionButtonClick(`practiceListActionButton-${practiceId}`, () => handlePracticeAchievePreview(row))}
            //CS-1071 - End
            tooltipMessage="Show Archive Agreement"
            tooltipPlacement='top' style={{ display: `${hideElement(!canAccessPracticeActionsAchieve)}` }}>
            <FileOpenOutlined fontSize="small" />
          </CustomIconButton>)
        }
        {approvalStatus === "APPROVED" &&
          (<CustomIconButton color="info" size="small" variant="outlined"
            //CS-1071 - Start
            onClick={() => handleActionButtonClick(`practiceListActionButton-${practiceId}`, () =>handleImportBaa(row))}
            //CS-1071 - End
            tooltipMessage="Import BAA"
            tooltipPlacement='top' style={{ display: `${hideElement(!canAccessPracticeActionsImportBaa || row.baaDetailId !== null)}` }}>
            <AssignmentReturnedOutlined fontSize="small" />
          </CustomIconButton>)
        }
          <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Practice Audit"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canAuditPractice)}` }}
          //CS-1071 - Start
          onClick={() =>handleActionButtonClick(`practiceListActionButton-${practiceId}`, () => handleClickPracticeAudit(row)) }
          //CS-1071 - End
        >
          <TrackChanges fontSize="small" />
        </CustomIconButton>
      </>
    );
  }

  const [dropDownDisabled, setDropDownDisable] = useState<DropdownDisable[]>([]); // Assuming you're managing this state

  const disableDropDowns = (fieldToDisable: DropdownDisable) => {
      setDropDownDisable((prevDisabled) => {
      
          const alreadyDisabled = prevDisabled.some(item => item.field === fieldToDisable.field);
  
          if (!alreadyDisabled) {
              return [...prevDisabled, fieldToDisable];
          }
          return prevDisabled;
      });
    }


  const [agencyData, setAgencyData] = useState<SearchAgency>({
    agencyName: undefined,
    phone: undefined,
    email: undefined,
    address: undefined,
    commType: undefined,
    agencyStatus: undefined,
    currentPage: 1,
    itemsPerPage: 100
  });

  
  useEffect(() => {

    let searchCriteria: SearchAgency = {
      agencyName: '',
      phone: '',
      email: '',
      address: '',
      commType: '',
      agencyStatus: '',
      currentPage: 0,
      itemsPerPage: 100
    };

    setAgencyData(searchCriteria)

      const fetchAgencies = async () => {
        try {
          const response = await getAllAgenciesList();
          setAgencyInfoList(response.data.data); // Adjust based on how your API returns data
        } catch (error) {
          console.error("Error fetching agencies:", error);
        }
      };

    fetchAgencies();
    dispatch(fetchActiveAgencyExecutives({ getAgencyAdmins: false, isInactive: true }))
  }, [dispatch, isAlertOnly]);

  const agencyOptions = useMemo(() => {
    let options: Option[] = [];
  
    if (agencyInfoList && Array.isArray(agencyInfoList)) {
      const sortedAgencyList = sortNames(agencyInfoList, 'agencyName');
  
      sortedAgencyList.forEach((agency: AgencyInfo) => {
        options.push({ label: agency.agencyName, value: agency.agencyId });
      });
    }
  
    return options;
  }, [agencyInfoList]);


  const accountRepOptions = useMemo(() => {
    let options: Option[] = [];
  
    if(userInfo.userRole != "ROLE_ACCOUNTEXECUTIVE"){
        if (agencyExecutives && agencyExecutives.length > 0) {
          
          const sortedRepList = sortNames(agencyExecutives, 'firstName');
          sortedRepList.forEach((rep: any) => {
            options.push({ label: `${rep.firstName} ${rep.lastName}`, value: rep.userId });
          });
        }
    }else{
        options.push({ label: `${userInfo.firstName} ${userInfo.lastName}`, value: userInfo.userId.toString() });
    }
  
    return options;
  }, [agencyExecutives]);



  useEffect(() => {
      if(userInfo.userRole === "ROLE_ACCOUNTEXECUTIVE"){
          const userId = userInfo.userId;
          setValue("userId", userId);
          disableDropDowns({ field: "userId", isDisabled: true });

          if (agencyOptions.length > 0) {
            const agencyId = agencyOptions[0]?.value;
            setValue("agencyId", parseInt(agencyId));
            disableDropDowns({ field: "agency", isDisabled: true });
        }

      }
    
      if (userInfo.userRole === "ROLE_AGENCYADMIN" && agencyOptions.length > 0) { 
            const agencyId = agencyOptions[0]?.value;
            console.log(typeof agencyId);

            setValue("agencyId", parseInt(agencyId));
            disableDropDowns({ field: "agency", isDisabled: true });
      }
  
  },[practiceInfo, agencyOptions])

  const fetchNotificationsForEntities = async () => {
    const practiceIdList = practiceInfo?.content?.map(practice => Number(practice.practiceId));
    const data = {
      notificationTypes: canAccessNotifications && accessibleNotifications ? accessibleNotifications : [],
      refEntityIds: practiceIdList ? practiceIdList : [],
      refEntity: "PRACTICE"
    };

    if(canAccessNotifications && practiceIdList){
      fetchNotificationsByRefEntities({ data: data, skipLoader: false });
    }
  }

  const handleFetchAlerts = async () => {
    const data = {
      notificationTypes: accessibleNotifications ? accessibleNotifications: [],
      entity: "PRACTICE"
    }
    if(canAccessNotifications){
       const response = await dispatch(fetchAlertEntityNumbers({ data: data, skipLoader: false })).unwrap();
      setTotalNotificationIds(response?.data?.totalNotificationIds)
    }
  }

  useEffect(() => {
    if(userInfo.notificationEnable && canAccessNotifications && 
      accessibleNotifications && accessibleNotifications.length>0){
      handleFetchAlerts();
    }
  }, [accessibleNotifications])

  useEffect(() => {
    if(userInfo.notificationEnable){
      fetchNotificationsForEntities();
    }
  }, [practiceInfo])

  useEffect(() => {
    const alertedPracticeIds = NotificationInfoByRefEntity?.map(notification => notification.entityId);
    if (alertedPracticeIds) {
      setAlertedPracticeIds(alertedPracticeIds);
    }

  }, [NotificationInfoByRefEntity])

  const groupedNotifications = useMemo(() => {
    const map = new Map<number, any[]>();
    NotificationInfoByRefEntity?.forEach((notif) => {
      const orderId = notif.entityId;
      if (!map.has(orderId)) {
        map.set(orderId, []);
      }
      map.get(orderId)?.push(notif);
    });
    return map;
  }, [NotificationInfoByRefEntity]);

  const handleStatusClick = (event: React.MouseEvent<HTMLElement>, details: any) => {
    const notificationsForPractice = groupedNotifications.get(details.practiceId) || [];

    const popupData = notificationsForPractice.map((notif) => ({
      notificationId: notif.notificationId,
      orderNumber: details.practiceName,
      description: notif.notificationMsg,
      dateTime: notif.auditTimestamp,
    }));

    setNotificationData(popupData);
    setStatusAnchorEl(event.currentTarget);
  };

  const handleAcknowledge = async (item: any) => {
    try {
      const notificationData = {
        notificationId: item.notificationId,
        comment: ""
      }
      const response = await dispatch(acknowledgeNotification(notificationData)).unwrap();
      if (response.message = "SUCCESS") {
        fetchNotificationsForEntities();
        handleFetchAlerts();
      }
      return response;
    } catch (err) {
      console.error("Failed to fetch wound codes:", err);
      return [];
    }
  }

  const formattedPracticeInfo: Row[] = useMemo(() => {
    let practices: Row[] = [];
    if (practiceInfo) {
      practices = practiceInfo.content.map((practice: any) => ({
        practiceName: practice.practiceName,
        //CS-1406 - Rendering practice name as link
        practiceNameLink: practice?.practiceId !== null && practice?.approvalStatus === "APPROVED" && canAccessPracticeActionsView ? (
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={(e) => { e.stopPropagation(); handleActionButtonClick(`practiceListActionButton-${practice?.practiceId}`, () => handlePracticeDetailsView(practice)) }} // CS-1555
            color={'#00B8D9'}
            textAlign="left"
          >
            {practice.practiceName}
          </Link>
        ) : (
          practice.practiceName
        ),
        contactName: fullName(practice.title, practice.contactFirstName, practice.contactMiddleName, practice.contactLastName),
        contactEmail: practice.contactEmail,
        contactPhone: practice.contactPhone,
        approvalStatus: userInfo.notificationEnable ? (
          <Box display="flex" alignItems="center" gap={1}>
            {alertedPracticeIds.includes(practice.practiceId) && (
              <Box
                onClick={(e) => { e.stopPropagation(); handleStatusClick(e, practice) }} // CS-1555
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: "#2196f3",
                  display: "inline-block",
                  cursor: "pointer",
                }}
              />
            )}
            <Typography variant="body2" sx={{ display: "inline-block" }}>
              {practice.approvalStatus === "APPROVED" ? (
                <span style={{ color: "#1aa457" }}>{practice.approvalStatus}</span>
              ) : (
                practice.approvalStatus
              )}
            </Typography>
          </Box>
        ) : (
          practice.approvalStatus === "APPROVED" ? (
            <span style={{ color: "#1aa457" }}>{practice.approvalStatus}</span>
          ) : (
            practice.approvalStatus
          )
        ),
        rawApprovalStatus: practice.approvalStatus, // CS-1555
        createdDate: formatDate(practice.requestTimestamp),
        action: actionComponent(practice),
        practiceId: practice.practiceId,
        agencyName: practice.agencyName,
        userId: practice.executivesNames.join(", ") || "N/A",
        title: practice.title,
        associateAgreementDocumentId: practice.associateAgreementDocumentId,
      }));
    };
    return practices;
  }, [practiceInfo, alertedPracticeIds]);

    const practiceOptions = useMemo(() => {
    let options: Option[] = [];
    if (practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0) {
      const sortedPracticeInfo: PracticeInfo[] = sortNames(practiceByUserRoleUserSlice, 'practiceName');
      sortedPracticeInfo?.map(practice => {
        options.push({ value: practice.practiceId, label: practice.practiceName });
      });
    }
    return options;
  }, [practiceByUserRoleUserSlice]);

  useEffect(() => {
    const fetchPractices = async () => {
      const res = await dispatch(getPracticesByUserRoleUserSlice(true));
      if (res) {
        setFetchPracticesCompleted(true);
      }
    };

    fetchPractices();
  }, [dispatch]);

  const clickClosePracticesPopup = () => {
    setShowPracticesPopup(false);
  };

  const handleNotification = () => {
    if (!isAlertOnly) {
      if (location.state != null && location.state.practiceListSearchCriteria != null && location.state.practiceListSearchCriteria.practiceId != null) {
        location.state.practiceListSearchCriteria = {
          ...location.state.practiceListSearchCriteria,
          practiceId: null
        }
      }
      setIsAlertOnly(true);
    } else {
      if (location.state != null && location.state.practiceListSearchCriteria != null && location.state.practiceListSearchCriteria.practiceId != null) {
        location.state.practiceListSearchCriteria = {
          ...location.state.practiceListSearchCriteria,
          practiceId: null
        }
      }
      setIsAlertOnly(false);

    }
  }
  
  const legacyItems = [
    { icon: <ModeOutlined color="info" />, text: "Edit" },
    { icon: <VisibilityOutlined color="info" />, text: "Preview" },
    { icon: <Checklist color="success" />, text: "Approve" },
    // { icon: <NoteAddOutlined color="info" />, text: "View Practice Request" }
    { icon: <ArchiveOutlined color="info" />, text: "View Archive Practice" }
  ];

  const totalRecords = practiceInfo?.totalElements ?? 0;
  return (
    <>
      { showPDF &&
        <PDFViewer
          isOpen={showPDF}
          onClose={handleClose}
          fileName={document?.documentName + ""}
          title={document?.documentName + ""}
          base64String={document?.content || ""}
        />
      }
      { showBaaPopup?.show &&
          <UploadBaaPopup 
          open={showBaaPopup.show }
          onClose={() => setShowBaaPopup({show : false, userEntity: "PRACTICE", details: null})}
          userEntity= {showBaaPopup.userEntity}
          details={showBaaPopup.details}
          />

      }
       { showPracticesPopup &&
      <PracticeApprovePopup onClose={clickClosePracticesPopup} open={showPracticesPopup} />
      }
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          px: { xs: 1, md: 3 },
          py: 2,
        }}
      >
        {/* <Header title="Practice List"  /> */}
        <Box sx={{ position: "relative", zIndex: 20, overflow: "visible" }}>
          <Collapse in={showCard} ref={filterPanelRef} onEntering={handleFilterPanelEntering} onEntered={handleFilterPanelEntered} onExited={handleFilterPanelExited}>
            <Card sx={filterPanelSx}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item md={3} xs={12}>
                    {/* <CustomTextField control={control} controllerName="practiceName" label="Practice Name" /> */}
                    <CustomDropdownField control={control} name="practiceId" label="Practice Name" placeholderText="Select practice" options={practiceOptions} size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="contactFirstName" label="Contact First Name" placeholder="Enter first name" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="contactLastName" label="Contact Last Name" placeholder="Enter last name" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    {/* CS-543  */}
                    <CustomTextField control={control} controllerName="contactEmail" label="Contact Email" placeholder="Enter email" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomPatternTextField control={control} label="Contact Phone Number" name="contactPhone" placeholder="Enter phone" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField name="approvalStatus" control={control} label="Practice Status" placeholderText="Select status" options={statusOptions} size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField name="agencyId" label="Agency" placeholderText="Select agency" control={control} options={agencyOptions} disabled={dropDownDisabled.some(item => item.field === "agency" && item.isDisabled)} size="small"/>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField name="userId" control={control} label="Account Rep" placeholderText="Select account rep" options={accountRepOptions} disabled={dropDownDisabled.some(item => item.field === "userId" && item.isDisabled)} size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <Button fullWidth size="large" startIcon={<SearchOutlined />} sx={{ ...primaryActionBtnSx, height: "42px", py: 0 }} type="submit" removeUpperCase>
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Collapse>
        </Box>
        <Box mt={2} sx={{ position: "relative", zIndex: 1 }}>
          <Card sx={{ ...cardSx, p: { xs: "14px !important", md: "18px !important" }, position: "relative", zIndex: 1 }}>
            <Grid container justifyContent="flex-end" alignItems="center" spacing={1.2} > {/* CS-1426 */}
              <Grid item xs={12} md>
                <Typography variant='h3' fontWeight={800} color="text.primary">Practice List</Typography>
              </Grid>
              <Grid item xs={12} md="auto">
                {canAccessNotifications && userInfo.notificationEnable
                  && totalNotificationIds && totalNotificationIds.length > 0 &&
                  <CustomIconButton
                    color="warning"
                    variant="contained"
                    tooltipMessage="Practice Notifications"
                    size="small"
                    notifyCount={totalNotificationIds?.length}
                    onClick={handleNotification}
                  >
                    {isAlertOnly ?
                      <Notifications />
                      :
                      <NotificationsOutlined />
                    }
                  </CustomIconButton>
                }
              </Grid>

              <Grid item xs={12} md="auto">
                <Button variant="outlined" color="info" onClick={toggleFilterPanel} startIcon={<SearchOutlined />} fullWidth sx={outlineBtnSx} removeUpperCase>
                  {showCard ? "Hide Filters" : "Show Filters"}
                </Button>
              </Grid>
              {/* CS-1370 - Start */}
              {canExportPracticeList &&
                <Grid item sm="auto">
                  <Box>
                    {!isMobile && (
                      <Button
                        id="customized-button-practice"
                        aria-controls={Boolean(anchorElMenu) ? "customized-menu-practice" : undefined}
                        aria-haspopup="true"
                        aria-expanded={Boolean(anchorElMenu) ? "true" : undefined}
                        variant="outlined"
                        disableElevation
                        onClick={handleMenuClick}
                        startIcon={<ExitToApp />}
                        sx={exportBtnSx}
                        removeUpperCase
                        endIcon={
                          <Box
                            component="span"
                            sx={{
                              display: "flex",
                              transition: "transform 0.3s ease",
                              transform: anchorElMenu ? "rotate(180deg)" : "rotate(0deg)",
                              padding: "2px"
                            }}
                          >
                            <KeyboardArrowDown />
                          </Box>
                        }
                      >
                        Export
                      </Button>
                    )}

                    <StyledMenu
                      id="customized-menu-practice"
                      MenuListProps={{ "aria-labelledby": "customized-button-practice" }}
                      anchorEl={anchorElMenu}
                      open={Boolean(anchorElMenu)}
                      onClose={handleMenuClose}
                      slotProps={{
                        paper: { sx: exportMenuPaperSx }
                      }}
                    >

                      <Box sx={{ px: 1, mb: 1 }}>
                        <Button
                          fullWidth
                          variant="outlined"
                          startIcon={<CloudDownload />}
                          onClick={() => handleExport("searchList")}
                          disabled={totalRecords > 1000}
                          sx={exportMenuItemBtnSx}
                          removeUpperCase
                        >
                          Export Search List
                        </Button>
                      </Box>

                      <Box sx={{ px: 1, mb: 1 }}>
                        <Button
                          fullWidth
                          variant="outlined"
                          startIcon={<CloudDownload />}
                          onClick={() => handleExport("details")}
                          disabled={totalRecords > 1000}
                          sx={exportMenuItemBtnSx}
                          removeUpperCase
                        >
                          Export Details List
                        </Button>
                      </Box>

                      {totalRecords > 1000 && (
                      <Box
                        sx={{
                          mx: 1,
                          p: 1.5,
                          mt: 1,
                          backgroundColor: "warning.light",
                          borderRadius: 1,
                          color: "warning.contrastText",
                        }}
                      >
                        <Typography variant="body2">
                          Export is available only when the list contains 1,000 records or fewer.
                          Maximum export size: 1000 records.
                        </Typography>
                      </Box>
                      )}
                    </StyledMenu>
                  </Box>
                </Grid>
              }
            </Grid>

            {canExportPracticeList && isMobile && (
              <Box mt={1}> {/* CS-1426 */}
                <Button
                  color="success"
                  variant="text"
                  onClick={(event) => handleMenuClick(event)}
                  startIcon={<DownloadOutlined fontSize="small" />}
                  sx={exportBtnSx}
                  removeUpperCase
                >
                  Export
                </Button>
              </Box>
            )}

            {/* CS-1370 - End */}
            <Table
              columns={columns}
              rows={fetchPracticesCompleted ? formattedPracticeInfo || [] : []}
              actionComponent={(row: any) => actionComponent(row)}
              emptyText="No Practice(s) Found"
              pageNumber={handlePagination}
              totalPages={fetchPracticesCompleted ? practiceInfo?.totalPages : 0}
              totalElementText={"Records: " + ((fetchPracticesCompleted && practiceInfo?.totalElements) ? practiceInfo?.totalElements : "0")}
              currentPageNumber={searchCriteria.currentPage - 1}
              showMenu={true}
              sortableColumns={practiceListSort.sortableColumns}
              serverSideSorting
              onSortChange={handleTableSort}
              controlledSortColumn={practiceListSort.controlledColumn(searchCriteria.sortBy)}
              controlledSortOrder={searchCriteria.sortOrder ?? null}
              // CS-1071 - Start
              currentPageKey={"practiceList"}
              uniqueValue="practiceId"
              activeButtonId={activeButtonId}
            // CS-1071 - End
              // CS-1555 - Start
              onRowClick={handleRowNavigateToEdit}
              clickableCards={true}
              // CS-1555 - End
              sx={tableSx}
            />
          </Card>
        </Box>
      </Box>
      {
        baaAlert?.show && 
        <CustomSingleAlert
        open={baaAlert?.show}
        singleAlertObj={baaAlert.obj}
        autoHideDuration={20000}
        onClose={() => setBaaAlert({show:false, obj:{message: "", alertType: "info" }})}
      />
      }
      {userInfo.notificationEnable &&
        <StatusInfoPopup
          anchorEl={statusAnchorEl}
          onAcknowledge={handleAcknowledge}
          onClose={() => {
            setStatusAnchorEl(null)
          }
          }
          rows={notificationData}
        />
      }
    </>
  );

}

export default PracticeList;